<template>
    <div style="background-color: #4D5151; height: 38px; padding-bottom: 12px ">
        <!--class="module page-header"-->
        <nav class="breadcrumbs">
            <div id="PagerSeguimiento_panel_navegacion" style="width: 90%;  padding-top:12px">
                <a href="https://www.zeleris.com/"  style="color: white;  font-size: 15px; padding-left: 5%; font-weight: bold;font-family:Heebo"> Home</a>
                <a  style="color: white;  font-size: medium; padding-left: 3%; font-size: 15px; font-weight: bold ;font-family:Heebo" >|</a>
                <a  style="color: white;  font-size: medium; padding-left: 3%; font-size: 15px; font-weight: bold ;font-family:Heebo" >{{titulo}}</a>

            </div>
        </nav>
        <!-- <h1 class="title--m">{{titulo}}</h1>
    <p class="text--smaller">{{texto}}</p>-->
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            titulo: String,
            texto: String,
        }
    }
</script>

<style scoped>
    .v-alert__content {
        padding-left: 10px;
    }

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-regular.woff');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-bold.woff');
        font-weight: bold;
    }
</style>